import React from 'react';
import PropTypes from 'prop-types';
import { HrFlexContainer, HrParagraph, HrWhite } from '@components/styles/hr-styles';
import { TabItem } from '@/vacancy_request/components/template-request-form/navigation-buttons/styled';
import styled from 'styled-components';

const StepperTabItem = styled(TabItem)`
  flex: 1 1 0;
  min-width: 0;
  text-align: center;

  p {
    margin: 0;
    padding: 0 8px;
  }

  .mobile-label {
    display: none;
  }

  @media (max-width: 768px) {
    height: 56px;

    p {
      font-size: 12px;
      padding: 0 4px;
    }

    .full-label {
      display: none;
    }

    .mobile-label {
      display: inline;
    }
  }
`;

export const RequestFormStepper = ({ steps, activeStep, onStepChange }) => {
  return (
    <HrFlexContainer justifyContent='space-evenly' backgroundColor={HrWhite}>
      {steps.map((step, index) => (
        <StepperTabItem key={step.id} className={activeStep >= index ? 'active' : ''} onClick={() => onStepChange(index)}>
          <HrParagraph color={activeStep >= index ? 'primary' : 'secondary'} fontWeight={activeStep >= index ? 'bold' : 'normal'}>
            <span className='full-label'>{step.label}</span>
            <span className='mobile-label'>{index + 1}</span>
          </HrParagraph>
          <div className={activeStep === index ? 'active' : ''} />
        </StepperTabItem>
      ))}
    </HrFlexContainer>
  );
};

RequestFormStepper.propTypes = {
  steps: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired,
  activeStep: PropTypes.number.isRequired,
  onStepChange: PropTypes.func.isRequired
};
